<template>
  <div>
    <app-autocomplete-client @coordonneesChange="setPlace" @codeChange="setCode"
    @afficherSlider="setSlider" :btnAdd="true" @sendPoints="setPoints"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import autocompleteClient from '@/components/filtres/autocompleteClient';
import * as types from '@/store/creationOpportunite/venteNumerique-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';

const Panier = createNamespacedHelpers('panier');
const Numerique = createNamespacedHelpers('venteNumerique');

export default {
  name: 'autocomplete',
  components: {
    appAutocompleteClient: autocompleteClient,
  },
  data() {
    return {
      valid: false,
      codeFace: '',
    };
  },
  computed: {
    ...Panier.mapGetters({
      panneauxLcPanier: 'panneauxLcPanier',
    }),
    ...Numerique.mapGetters({
      getAddress: 'address',
    }),
    address: {
      get() {
        return this.getAddress;
      },
      set(value) {
        this.setFilterAddress(value);
      },
    },
  },
  methods: {
    ...Numerique.mapMutations({
      setFilterAddress: types.SET_FILTER_ADDRESS,
      setAffichageCercle: types.SET_AFFICHAGE_CERCLE,
      setZoomCarto: types.SET_ZOOM_CARTO,
      setPointsAddress: types.SET_POINTS_ADDRESS,
    }),
    ...Numerique.mapActions({
      actionsRecuperationPanneaux: 'recuperationPanneaux',
    }),
    setPlace(place) {
      this.codeFace = '';
      this.address = place;
      this.valid = place !== null;
      this.setAffichageCercle(false);
      this.recherchePanneaux();
    },
    setPoints(points) {
      this.setPointsAddress(points);
      this.recherchePanneaux();
    },
    setCode(code) {
      this.codeFace = encodeURI(code);
      this.valid = (code !== null && code !== '');
      this.recherchePanneaux();
    },
    setSlider(afficherSlider) {
      this.afficherSlider = afficherSlider;
    },
    recherchePanneaux() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.actionsRecuperationPanneaux({ address: this.address,
        codeFace: this.codeFace,
        rayon: this.rayon,
        valid: this.valid,
      }).then(() => {
        loadingComponent.close();
      }).catch((e) => {
        loadingComponent.close();
        gestionErreur('Erreur lors de la recherche des panneaux numériques liée à l\'autocomplete', e);
      });
    },
  },
  mounted() {
  },
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteNumerique/filtres/autocomplete.vue